// Results pager — progressive "load more".
//
// Enhances a server-rendered list: hides numbered pagination and appends the next
// page of rows via the secured endpoint. Idempotent + re-runnable so the search
// controller can re-init after swapping in fresh results.

var skeleton = require('./Skeleton');

// Placeholder rows appended below the list while the next page loads.
function addSkeletonRows(items, count) {
  items.insertAdjacentHTML('beforeend', skeleton.itemsHtml(count));

  return function remove() {
    var ghosts = items.querySelectorAll('.mad-search-list__item--skeleton');
    for (var i = 0; i < ghosts.length; i++) {
      ghosts[i].parentNode.removeChild(ghosts[i]);
    }
  };
}

function buildButton(label) {
  var wrap = document.createElement('div');
  wrap.className = 'mad-search-list__load-more-wrapper';

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'mad-button mad-button1 mad-search-list__load-more-btn';

  var span = document.createElement('span');
  span.textContent = label;
  btn.appendChild(span);
  wrap.appendChild(btn);

  return { wrap: wrap, btn: btn, span: span };
}

function enhanceList(list, cfg) {
  if (list.getAttribute('data-pager-init') === '1') {
    return; // Already enhanced this node.
  }
  list.setAttribute('data-pager-init', '1');

  var query = list.getAttribute('data-query');
  if (!query) {
    return;
  }

  var maxPages = parseInt(list.getAttribute('data-maxpages'), 10) || 0;
  var current  = parseInt(list.getAttribute('data-paged'), 10) || 1;
  if (maxPages <= current) {
    return; // Nothing more to load.
  }

  var items = list.querySelector('.mad-search-list__items');
  if (!items) {
    return;
  }

  var pagination = list.querySelector('.mad-search-list__pagination');
  if (pagination) {
    pagination.setAttribute('hidden', '');
  }

  var i18n = cfg.i18n || {};
  var ui = buildButton(i18n.loadMore || 'Load more');
  items.parentNode.insertBefore(ui.wrap, items.nextSibling);

  var perPage = parseInt(list.getAttribute('data-limit'), 10) || 3;

  ui.btn.addEventListener('click', function () {
    ui.btn.disabled = true;
    ui.span.textContent = i18n.loading || 'Loading…';

    var next = current + 1;
    var clearSkeletons = addSkeletonRows(items, Math.min(perPage, 3));
    var sep = cfg.endpoint.indexOf('?') === -1 ? '?' : '&';
    var url = cfg.endpoint + sep +
      's=' + encodeURIComponent(query) +
      '&paged=' + encodeURIComponent(next) +
      '&posttypes=' + encodeURIComponent(list.getAttribute('data-posttypes') || '') +
      '&limit=' + encodeURIComponent(list.getAttribute('data-limit') || '') +
      '&exclude=' + encodeURIComponent(list.getAttribute('data-exclude') || '') +
      '&lang=' + encodeURIComponent(list.getAttribute('data-lang') || '') +
      '&imagefit=' + encodeURIComponent(list.getAttribute('data-imagefit') || '');

    fetch(url, {
      method: 'GET',
      headers: { 'X-WP-Nonce': cfg.nonce || '' },
      credentials: 'same-origin'
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        clearSkeletons();
        if (data && data.success && data.html) {
          items.insertAdjacentHTML('beforeend', data.html);
          current = data.paged || next;
          if (data.max_num_pages) {
            maxPages = data.max_num_pages;
          }
          if (current >= maxPages) {
            ui.wrap.parentNode.removeChild(ui.wrap);
          } else {
            ui.btn.disabled = false;
            ui.span.textContent = i18n.loadMore || 'Load more';
          }
        } else {
          restoreFallback();
        }
      })
      .catch(restoreFallback);

    function restoreFallback() {
      clearSkeletons();
      if (ui.wrap.parentNode) {
        ui.wrap.parentNode.removeChild(ui.wrap);
      }
      if (pagination) {
        pagination.removeAttribute('hidden');
      }
    }
  });
}

function initResultsPager(root) {
  var cfg = window.madSearchResults;
  if (!cfg || !cfg.endpoint || typeof window.fetch !== 'function') {
    return;
  }
  var scope = root || document;
  var lists = scope.querySelectorAll('.mad-search-list[data-query]');
  for (var i = 0; i < lists.length; i++) {
    enhanceList(lists[i], cfg);
  }
}

// Exposed so the search controller can re-init after DOM swaps.
window.madSearchInitPager = initResultsPager;

if (document.readyState !== 'loading') {
  initResultsPager(document);
} else {
  document.addEventListener('DOMContentLoaded', function () { initResultsPager(document); });
}

module.exports = {};
